import { useState } from 'react';

import { requestDeskForAnnualPlan } from 'data-layer';
import { DeskIcon } from 'icons';
import { FormattedMessage } from 'localization';
import { ConfirmationWindow, useShowError } from 'ui';
import Checkbox from 'ui/src/atoms/Checkbox/Checkbox';
import { Copy } from 'ui/src/atoms/Copy/Copy';

type InvoiceCheckingModalContentProps = {
  onCancel: () => void;
};

const DeskRequestForAnnualModalContent = ({ onCancel }: InvoiceCheckingModalContentProps) => {
  const [acceptedConditions, setAcceptedConditions] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const { onShowError } = useShowError();

  const onSubmit = async () => {
    if (!acceptedConditions || isLoading) {
      return;
    }
    setIsLoading(true);
    try {
      await requestDeskForAnnualPlan();
      onCancel?.();
    } catch (error) {
      onShowError(<FormattedMessage id="new-courier-page.methods.error" />);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <ConfirmationWindow
        title={<FormattedMessage id="desk-app.outvio-desk" />}
        cancelButtonTitle={<FormattedMessage id="general.cancel" />}
        onCancel={onCancel}
        confirmButtonTitle={<FormattedMessage id="settings.couriers-list.send" />}
        onConfirm={onSubmit}
        disabledConfirm={!acceptedConditions || isLoading}
        theme="info"
        headingIcon={<DeskIcon width={24} height={24} />}
        content={
          <div className="flex flex-col gap-4">
            <Copy>
              <FormattedMessage id="desk-app.desk-app-description" />
            </Copy>
            <Copy>
              <FormattedMessage id="desk-app.annual-plan-only" />
            </Copy>

            <Checkbox
              className="my-4 ml-3"
              name="accept-conditions"
              checked={acceptedConditions}
              onChange={(e) => setAcceptedConditions(e.target.checked)}
              label={<FormattedMessage id="desk-app.annual-plan-agreement" />}
              theme="info"
            />
          </div>
        }
      />
    </>
  );
};

export default DeskRequestForAnnualModalContent;
